


























































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import LaporanSvc from "@/services/LaporanRekapSerahTerimaDarah";
import {
  OpsiNilai,
  RekapSerahTerimaFilter,
  RekapSerahTerimaRow,
  RekapSerahTerimaSummary,
  STATUS_WARNA
} from "@/types/order_bank_darah";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";

@Component({ components: { VCDateTimePicker, UnitRuangPicker } })
export default class LaporanRekapSerahTerimaDarahPage extends Vue {
  filter: RekapSerahTerimaFilter & {
    tgl_start: string;
    tgl_end: string;
    jenis: string[];
    status: string[];
  } = {
    tgl_start: moment().startOf("month").format("YYYY-MM-DD"),
    tgl_end: moment().format("YYYY-MM-DD"),
    unit_id: null,
    jenis: [],
    status: [],
    sampel: "",
    term: null
  };

  rows: RekapSerahTerimaRow[] = [];
  summary: RekapSerahTerimaSummary | null = null;
  jenisItems: OpsiNilai[] = [];
  statusItems: OpsiNilai[] = [];
  maksBaris = 0;
  loading = false;
  downloading = false;

  readonly sampelItems = [
    { text: "Semua", value: "" },
    { text: "Diterima", value: "ada" },
    { text: "Draft", value: "tidak" }
  ];

  readonly headers = [
    { text: "Diterima", value: "diterima_at", width: "120px" },
    { text: "No Order / Jenis", value: "nomor", width: "170px" },
    { text: "Pasien", value: "pasien", sortable: false },
    { text: "Unit / Bangsal", value: "unit", sortable: false },
    { text: "Gol. Darah / Serah Terima", value: "darah", sortable: false, width: "140px" },
    { text: "Komponen Diminta", value: "komponen", sortable: false },
    { text: "Mengetahui", value: "ttd", sortable: false, width: "220px" },
    { text: "Status Order", value: "status", width: "120px" },
    { text: "Jeda Kirim → Terima", value: "jeda_kirim_terima_menit", width: "110px" }
  ];

  get tglStartDate(): Date | null {
    return composeDate(this.filter.tgl_start);
  }
  set tglStartDate(val: Date | null) {
    this.filter.tgl_start = toDateString(val) || this.filter.tgl_start;
  }

  get tglEndDate(): Date | null {
    return composeDate(this.filter.tgl_end);
  }
  set tglEndDate(val: Date | null) {
    this.filter.tgl_end = toDateString(val) || this.filter.tgl_end;
  }

  get tiles(): { label: string; nilai: string | number; warna?: string }[] {
    const s = this.summary;
    if (!s) return [];
    return [
      { label: "Total Serah Terima", nilai: s.total },
      { label: "Diterima", nilai: s.diterima, warna: "green" },
      { label: "Draft", nilai: s.draft, warna: "orange" },
      { label: "Order Dibatalkan", nilai: s.dibatalkan, warna: "grey" },
      { label: "Rata-rata Jeda Kirim → Terima", nilai: this.menit(s.rata_jeda_kirim_terima_menit) }
    ];
  }

  mounted() {
    this.load();
  }

  async load() {
    this.loading = true;
    try {
      const res = await LaporanSvc.list(this.filter);
      this.rows = res.rows || [];
      this.summary = res.summary;
      this.jenisItems = res.jenis_options;
      this.statusItems = res.status_options;
      this.maksBaris = res.maks_baris;
    } catch {
      this.rows = [];
      this.summary = null;
    } finally {
      this.loading = false;
    }
  }

  async unduh() {
    this.downloading = true;
    try {
      await LaporanSvc.downloadExcel(this.filter).catch(() => undefined);
    } finally {
      this.downloading = false;
    }
  }

  warnaStatus(status: string): string {
    return STATUS_WARNA[status] || "blue-grey";
  }

  golDarah(item: RekapSerahTerimaRow): string {
    if (!item.golongan_darah) return "Gol. -";
    const rh = item.rhesus === "positif" ? " Rh+" : item.rhesus === "negatif" ? " Rh-" : "";
    return `Gol. ${item.golongan_darah}${rh}`;
  }

  petugas(nama: string | null, jam: string | null): string {
    if (!nama && !jam) return "belum diterima";
    return `${nama || "-"} (${jam ? this.waktu(jam) : "-"})`;
  }

  waktu(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  menit(val: number | null): string {
    if (val === null || val === undefined) return "-";
    if (val < 60) return `${val} mnt`;
    const jam = Math.floor(val / 60);
    return `${jam} j ${val % 60} mnt`;
  }
}
